<template>
  <div>
    <div class="no-print">
      <ImportDeck @input="deck = { ...deck, ...$event }" class="mr-1" />
      <ExportDeck :deck="deck" :note="note" :name="name" class="mr-1" />

      <b-form-group
        label="Deck name"
        description="This name will be shown in public and private listings"
      >
        <b-form-input
          v-model="name"
          :placeholder="deck.hero.name || 'Please enter a name for your deck'"
          size="lg"
        />
      </b-form-group>
      <template v-if="!$store.state.userProfile">
        Please log in to save your decks.
      </template>
      <b-button v-else :disabled="!(name || deck.hero.name)" @click="saveDeck">
        Save
      </b-button>
    </div>
    <UnmatchedDeckEditor
      :deck="deck"
      :note.sync="note"
      isEditable
      :bggLink.sync="bggLink"
      ref="deckEditor"
    />
  </div>
</template>

<script>
import UnmatchedDeckEditor from "@/components/UnmatchedDeckEditor.vue";

import ExportDeck from "@/components/ExportDeck.vue";
import ImportDeck from "@/components/ImportDeck.vue";

import api from "@/api";

import { UnmatchedDeck } from "@/Unmatched";

export default {
  name: "CreateDeck",
  metaInfo: {
    title: "New Deck"
  },
  components: {
    UnmatchedDeckEditor,
    ExportDeck,
    ImportDeck
  },
  data() {
    return {
      deck: new UnmatchedDeck(),
      name: "",
      note: "",
      bggLink: ""
    };
  },
  methods: {
    async saveDeck() {
      try {
        const deck = await api.createDeck({
          deck: this.deck,
          name: this.name || this.deck.hero.name,
          note: this.note,
          bgg: this.$refs.deckEditor.bggThreadId()
        });
        this.$root.$bvToast.toast("Your deck has been created", {
          title: "Success",
          variant: "success"
        });
        this.$router.push({
          name: "EditVersion",
          params: { id: deck.version_id, familyId: deck.deck_id }
        });
      } catch (err) {
        this.$root.$bvToast.toast(err.response.statusText, {
          title: "Error creating deck",
          variant: "danger"
        });
      }
    }
  }
  // watch: {
  //     'deck': {
  //         handler: function() {
  //             this.userDeck = JSON.stringify(this.deck, null, 2);
  //             this.humanReadableDeck = serializeToHuman(this.deck);
  //             if (this.autoSave) {
  //               this.localStorageSave();
  //             }
  //         },
  //         deep: true
  //     }
  // },
  // mounted: function() {

  //     this.$nextTick(() => {
  //         const urlParams = new URLSearchParams(window.location.search);
  //         const urlDeck = urlParams.get('deck');
  //         if (urlDeck) {
  //           this.autoSave = false;
  //           const humanDeck = decodeURIComponent(urlDeck);
  //           this.parseHumanDeck(humanDeck);
  //           return
  //         } else if (localStorage.getItem('unmatched-deck')) {
  //             const deck = JSON.parse(localStorage.getItem('unmatched-deck'));
  //             this.deck.name = deck.name
  //             this.deck.appearance = deck.appearance
  //             this.deck.hero = deck.hero
  //             this.deck.sidekick = deck.sidekick
  //             deck.cards.forEach((card, index) => {
  //                 this.$set(this.deck.cards, index, card);
  //             })
  //         }
  //     });
  // },
};
</script>
